/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { useOktaAuth } from '@okta/okta-react';
import React, {useContext, useEffect, useState} from 'react';
// import { Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import '../stylesheets/App.css';
import classes from './NavbarEnlighten.module.css';
import NavDropdown from './NavDropDown';
import Site from '../components/dropdowns/SiteLocation';
import Department from '../components/labels/Department';
import DepartmentText from '../components/texts/DepartmentText';
import SiteText from '../components/texts/SiteText';
import UserPrefContext from '../../context/userPrefContext';
import AuthContext from '../../context/authContext';
import SiteDropDown from './SiteDropDown';
import AutoLogout from '../../AutoLogout';
import CompanyContext from '../../context/companyContext';
import Logout from '../../Logout'

// import dictionaryContext from '../../context/dictionaryContext';

const NavbarEnlighten = (props) => {
  const { authState, oktaAuth } = useOktaAuth();
  const userPrefCtx = useContext(UserPrefContext);
  const authCtx = useContext(AuthContext)
  const companyCtx = useContext(CompanyContext)
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  // used to force to reload of SiteDropDown
  const [siteLoc, setSiteLoc] = useState('')
  // used to force reload of NavDropDown
  const [navDroDownRefreshed, setNavDroDownRefreshed] = useState('')
  const [doLogout, setDoLogout] = useState(false)
//   const [doRefresh, setDoRefresh] = useState(false)
  //   const dictCtx = useContext(dictionaryContext);
  const login = async () => oktaAuth.signInWithRedirect();
  // const logout = async () => oktaAuth.signOut();
  const titles = [
    {
        mode: "main",
        title: "EnlightenMD"
    },
    {
        mode: "user_prefs",
        title: "EnlightenMD"
    },
    {
        mode: "him",
        title: "EnlightenMD"
    },
    {
        mode: "ipad",
        title: "EnlightenMD iPad"
    },

  ]


  const title = (mode) => {
    const aTitle = titles.find(t => t.mode === mode)
    // console.log("aTitle", aTitle)
    return aTitle !== undefined ? aTitle.title : '*** invalid mode'
  }


//   const refreshMe = () => {
//     setDoRefresh(true)
//   }

//     useEffect(() => {
//         if (doRefresh) {
//             // refresh components - we need to refresh Site Drop Down
//             // - it doesn't matter what we set it to, just need to change it
//             console.log("NavbarEnlighten - do refresh", doRefresh)
//             setSiteLoc(new Date().toDateString())
//             setDoRefresh(false)
//         }
//     }, [doRefresh])


    const refreshSiteDropDown = () => {
        // console.log("NavbarEnlighten -refreshSiteDropDown calling setSiteLoc")
        setSiteLoc(new Date().toDateString())
    }

    const refreshNavDropDown = () => {
        // console.log("NavbarEnlighten -refreshSiteDropDown calling setSiteLoc")
        setNavDroDownRefreshed(new Date().toDateString())
    }


    const loggedOut = () => {
        setDoLogout(false)
    }
//   console.log("NavbarEnlighten - props", props)


//   useEffect(() => {
//     // console.log("NavbarEnlighten - authCtx?.authMode", authCtx?.authMode , "authCtx", authCtx, "authCtx.isAuthenticated", authCtx.isAuthenticated, "authState", authState)
//     if (authCtx?.authMode === 'DB' && authCtx.isAuthenticated) {
//         // console.log("NavbarEnlighten - auth is DB; isAuthenticated")
//         setIsAuthenticated(true)
//         // setSiteLoc('TEST DB')
//     } else if (authCtx?.authMode === 'OKTA' && authState.isAuthenticated) {
//         // console.log("NavbarEnlighten - auth is OKTA; isAuthenticated")
//         // setSiteLoc('TEST OKTA')
//         setIsAuthenticated(true)
//     } else {
//         // console.log("NavbarEnlighten - not authenticated")
//         setIsAuthenticated(false)
//     }
//   }, [authCtx.authMode, authCtx?.isAuthenticated, authState?.isAuthenticated])

  return (
    <div className='navbar1style '>
        <Navbar collapseOnSelect expand='lg' className='navbarcolor'>
            <Nav.Link href='/' className='me-auto '>
            <h2 
                className="bi bi-house-fill house_icon_mobile_class" 
                style={{ color: 'white'}}
                //style={{ color: 'white', marginLeft: '1.5rem' }}
            >
                {title(props.mode)}
            </h2>
            </Nav.Link>
            {/* { userPrefCtx.dictDeviceType !== 'mobile' &&
                <div style={{ paddingRight: '2%', margin: 'auto' }}>
                    <h1 className={classes.title}>{companyCtx.company.company_name}</h1>
                </div>
            } */}
            { userPrefCtx.dictDeviceType === 'desktop' &&
                <div style={{ paddingRight: '2%', margin: 'auto' }}>
                    <h1 className={classes.title}>{companyCtx.company.company_name}</h1>
                </div>
            }
            {/* {isAuthenticated && */}
            {/* Do not show Site dropddown and navdropdown for ipad and him users */}
            {!!!authCtx.userInfo.is_him_user && !!!authCtx.userInfo.is_ipad_user &&
                ((authCtx.authMode !== 'OKTA' && authCtx?.isAuthenticated) || (authCtx.authMode === 'OKTA' && authState?.isAuthenticated)) && 
                <>
                    <SiteDropDown site={siteLoc} /*forceRefresh={refreshSiteDropDown}*/ /*isAuthenticated={isAuthenticated} */ />
                    

                    <NavDropdown 
                        mode={props.mode} 
                        onModeChange={(newMode) => props.onModeChange(newMode)} 
                        //className="dropdown_class"
                        // className={classes.dropdown_class}
                        // forceRefresh={refreshNavDropDown} 
                        // refreshed={navDroDownRefreshed}
                        /*needToRefresh={refreshMe}*/
                    />
                </>
            }
            { !!authCtx.userInfo.is_ipad_user &&
                ((authCtx.authMode !== 'OKTA' && authCtx?.isAuthenticated) || (authCtx.authMode === 'OKTA' && authState?.isAuthenticated)) &&
                <>
                    <Button 
                        onClick={() => setDoLogout(true)}
                        variant='outline-light' 
                        className='navbar-btn' 
                    >
                        Logout
                    </Button>
                    <Logout doLogout={doLogout} onLoggedOut={loggedOut} />

                </>
            }



        </Navbar>
        {/* {!!props.authMode && props.authMode !== 'OKTA' && */}
        {!!companyCtx.company.auth_mode && companyCtx.company.auth_mode !== 'OKTA' &&
            <AutoLogout />
        }
    </div>
  );
};
export default NavbarEnlighten;